import { createFileRoute } from "@tanstack/react-router";
import { ProfilForm } from "@/components/qorum/ProfilForm";
import { socialMeta } from "@/lib/seo-meta";

export const Route = createFileRoute("/compte/profil")({
  head: () => ({
    meta: [{ title: "Mon Profil — Hōjin" }, { name: "robots", content: "noindex, nofollow" },
      ...socialMeta({
        title: "Mon Profil — Hōjin",
        description: "Mon Profil — Hōjin",
        url: "https://hojin.ai/compte/profil",
        image: "secretaire",
        card: "summary_large_image",
      }),
    ],
    links: [{ rel: "canonical", href: "https://hojin.ai/compte/profil" }],
  }),
  component: () => <ProfilForm />,
});
